import { Select } from '@alifd/next';
import wrapper from './next-wrapper';
const FormSelect = wrapper(Select, 'CbayelFormSelect');
export default FormSelect;
